
import {
  FETCH_BINBATCH_REQUEST,
  FETCH_BINBATCH_SUCCESS,
  FETCH_BINBATCH_FAILURE,
  FETCH_ORGANIZATION_REQUEST,
  FETCH_ORGANIZATION_SUCCESS,
  FETCH_ORGANIZATION_FAILURE,
  FETCH_SEASON_REQUEST,
  FETCH_SEASON_SUCCESS,
  FETCH_SEASON_FAILURE,
  FETCH_BINMASTER_REQUEST,
  FETCH_BINMASTER_SUCCESS,
  FETCH_BINMASTER_FAILURE,
  FETCH_DRYING_REQUEST,
  FETCH_DRYING_SUCCESS,
  FETCH_DRYING_FAILURE,
  FETCH_DRYINGLINE_REQUEST,
  FETCH_DRYINGLINE_SUCCESS,
  FETCH_DRYINGLINE_FAILURE,
} from "./actionTypes";


export const fetchBinBatchRequest = () => ({
  type: FETCH_BINBATCH_REQUEST,
});

export const fetchBinBatchSuccess = (data) => ({
  type: FETCH_BINBATCH_SUCCESS,
  payload: data,
});

export const fetchBinBatchFailure = (error) => ({
  type: FETCH_BINBATCH_FAILURE,
  payload: error,
});


export const fetchOrganizationRequest = () => ({
  type: FETCH_ORGANIZATION_REQUEST,
});

export const fetchOrganizationSuccess = (data) => ({
  type: FETCH_ORGANIZATION_SUCCESS,
  payload: data,
});

export const fetchOrganizationFailure = (error) => ({
  type: FETCH_ORGANIZATION_FAILURE,
  payload: error,
});


export const fetchSeasonRequest = () => ({
  type: FETCH_SEASON_REQUEST,
});

export const fetchSeasonSuccess = (data) => ({
  type: FETCH_SEASON_SUCCESS,
  payload: data,
});

export const fetchSeasonFailure = (error) => ({
  type: FETCH_SEASON_FAILURE,
  payload: error,
});


export const fetchBinMasterRequest = () => ({
  type: FETCH_BINMASTER_REQUEST,
});

export const fetchBinMasterSuccess = (data) => ({
  type: FETCH_BINMASTER_SUCCESS,
  payload: data,
});

export const fetchBinMasterFailure = (error) => ({
  type: FETCH_BINMASTER_FAILURE,
  payload: error,
});


export const fetchDryingRequest = () => ({
  type: FETCH_DRYING_REQUEST,
});

export const fetchDryingSuccess = (data) => ({
  type: FETCH_DRYING_SUCCESS,
  payload: data,
});

export const fetchDryingFailure = (error) => ({
  type: FETCH_DRYING_FAILURE,
  payload: error,
});


export const fetchDryingLineRequest = () => ({
  type: FETCH_DRYINGLINE_REQUEST,
});

export const fetchDryingLineSuccess = (data) => ({
  type: FETCH_DRYINGLINE_SUCCESS,
  payload: data,
});

export const fetchDryingLineFailure = (error) => ({
  type: FETCH_DRYINGLINE_FAILURE,
  payload: error,
});